export const WORKSPACE_SUGGESTER_STRATEGY = 'feed_name';
